/**
 * Verb whitelist for ``<area>.<entity>.<verb_past>`` event names.
 *
 * Verbatim from ``plans/PLAN_POSTHOG_05_GOVERNANCE.md`` § "Verb-tense
 * enforcement". The regex in ``capture.ts`` only enforces shape (3
 * lowercase dot-separated segments); past-tense correctness is
 * non-regular, so it lives as a dictionary check against this list.
 *
 * New verbs require a PR adding them here AND to the catalog in
 * ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md``. The monthly audit
 * compares observed event names against this whitelist and flags any
 * drift.
 */

export const ALLOWED_VERBS = [
  "viewed",
  "opened",
  "closed",
  "started",
  "ended",
  "submitted",
  "completed",
  "failed",
  "created",
  "updated",
  "deleted",
  "revoked",
  "activated",
  "deactivated",
  "suspended",
  "reactivated",
  "accepted",
  "expired",
  "sent",
  "received",
  "clicked",
  "selected",
  "deselected",
  "focused",
  "blurred",
  "added",
  "removed",
  "changed",
  "switched",
  "filtered",
  "sorted",
  "searched",
  "exported",
  "configured",
  "enrolled",
  "denied",
  "surfaced",
  "captured",
  "requested",
  "composed",
  "blocked",
  "attempted",
  // "saved" is used by ``admin.settings.saved`` and
  // ``account.settings.saved``. Plan_05's initial whitelist missed it
  // (catalog-vs-whitelist drift); added here per PR-4 work item Q6.
  "saved",
] as const;

export type AllowedVerb = (typeof ALLOWED_VERBS)[number];

const ALLOWED_VERB_SET: ReadonlySet<string> = new Set(ALLOWED_VERBS);

export function isAllowedVerb(verb: string): boolean {
  return ALLOWED_VERB_SET.has(verb);
}
